import {
  BUCKET_COLOR_VAR,
  BUCKET_LABEL,
  type Bucket,
  type EmailCardData,
} from "@/lib/emails";

import { EmailCard } from "./EmailCard";

interface BucketColumnProps {
  bucket: Bucket;
  emails: EmailCardData[];
  onSelect?: (id: string) => void;
}

export function BucketColumn({ bucket, emails, onSelect }: BucketColumnProps) {
  return (
    <section
      className="flex h-full min-w-0 flex-col gap-3"
      data-testid="bucket-column"
      data-bucket={bucket}
    >
      <header className="flex items-center justify-between gap-2 border-b border-op-border pb-2">
        <div className="flex items-center gap-2 min-w-0">
          <span
            aria-hidden
            className="h-2 w-2 shrink-0 rounded-full"
            style={{ backgroundColor: BUCKET_COLOR_VAR[bucket] }}
          />
          <h2 className="truncate text-sm font-semibold uppercase tracking-wider text-op-primary">
            {BUCKET_LABEL[bucket]}
          </h2>
        </div>
        <span className="shrink-0 rounded-full bg-op-elevated px-2 py-0.5 text-xs text-op-secondary">
          {emails.length}
        </span>
      </header>
      <div className="flex flex-col gap-2">
        {emails.length === 0 ? (
          <EmptyBucket />
        ) : (
          emails.map((email) => (
            <EmailCard key={email.id} email={email} onSelect={onSelect} />
          ))
        )}
      </div>
    </section>
  );
}

function EmptyBucket() {
  return (
    <p
      className="rounded-lg border border-dashed border-op-border px-3 py-6 text-center text-xs text-op-muted"
      data-testid="bucket-empty"
    >
      No emails here. Showing emails from the last 7 days.
    </p>
  );
}
